"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialTimeoutError = void 0;
class SerialTimeoutError extends Error {
    constructor(message = "Serial read timed out") {
        super(message);
        this.name = "SerialTimeoutError";
    }
}
exports.SerialTimeoutError = SerialTimeoutError;
//# sourceMappingURL=errors.js.map